let STORE = STORE || {};

(()=> {

  /**
   * ディレクトリより店舗番号を取得
   * @returns {String} result 店舗番号
   */
  STORE.UTIL.getStoreCode = ()=> {
    let pathName = location.pathname;
    let result   = pathName.replace(/^\/(\d{3})\/.*/, '$1');
		if(result === '000') {
			result = '086';
		}
    return result;
  };

  /**
   * 本番ドメインか反映
   */
  STORE.UTIL.isProdDomein = ()=> {
    return _.contains(STORE.CONS.PROD_DOMAINS, location.hostname);
  };

  STORE.UTIL.isDevDomein = ()=> {
    return _.contains(STORE.CONS.DEV_DOMAINS, location.hostname);
  };

	/**
	 * 全角を半角へ変換
	 * @param {String} aStr - 変換対象文字列
	 * @return              - 変換済み文字列
	 */
	STORE.UTIL.convert_zen2han = (aStr)=> {
		return aStr.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function(s) {
			return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
		});
	};

  /**
	 * TTSで自動付与される文頭、文末のpタグを除去
	 * @param  {String} aText	- 投稿文字列
	 * @return {String}			- 除去済み文字列
	 */
	STORE.UTIL.getStrDelParagraph = (aText)=> {
		return aText;
			// .replace(/^<p>(.*)<\/p>$/, '$1')
			// .replace(/<\/p><p>/g, '')
			// .replace(/<\/?p>/g, '');
	};

  /**
   * 記事の開始日が有効か判定
   * @param {String} aStartDate - TTS記事開始日文字列
   * @return {Boolean}          - 判定結果
   */
  STORE.UTIL.isTtsStartDate = (aDate)=> {
    let convDate = aDate.replace(/^(\d{4})(\d{2})(\d{2})$/, '$1/$2/$3');
		let today    = new Date();
		let yyyy     = today.getFullYear();
		let mm       = today.getMonth() + 1;
		let dd       = today.getDate();
    if(new Date(`${yyyy}/${mm}/${dd}`) >= new Date(convDate).getTime()) {
      return true;
    } else {
      return false;
    }
  };

  /**
   * 記事の終了日が有効か判定
   * @param {String} aEndDate - TTS記事終了日文字列
   * @return {Boolean} result   - 判定結果
   */
  STORE.UTIL.isTtsEndDate = (aDate)=> {
    let convDate = aDate.replace(/^(\d{4})(\d{2})(\d{2})$/, '$1/$2/$3');
		let today    = new Date();
		let yyyy     = today.getFullYear();
		let mm       = today.getMonth() + 1;
		let dd       = today.getDate();


	if(new Date(`${yyyy}/${mm}/${dd}`).getTime() <= new Date(convDate).getTime()) {
      return true;
    } else {
      return false;
    }
  };

  /**
	 * TTS 記事公開日と現在日を比較し有効な記事か判定
	 * @param  {String} aTtsDate	- TTSで設定された日時（yyyymmdd）
	 * @param  {String('start'|'end')} aCond - 開始日 or 終了日
	 * @return {Boolean}			- 有効記事の場合はTrue
	 */
	STORE.UTIL.checkTtsArticleDate	= (aTtsDate, aCond) => {
		const nowDate			= new Date();
		const yyyy				= nowDate.getFullYear();
		const mm				= nowDate.getMonth() + 1;
		const dd				= nowDate.getDate();
		const forCompareDate	= new Date(`${yyyy}/${mm}/${dd}`).getTime();
		let convTtsDate			= aTtsDate.replace(/(\d{4})(\d{2})(\d{2})/, '$1/$2/$3');
		const forCondDate		= new Date(convTtsDate).getTime();

		switch(aCond) {
			case 'start':
				if(forCondDate <= forCompareDate) {
					return true;
				} else {
					return false;
				}
			break;
			case 'end':
				if(forCondDate >= forCompareDate) {
					return true;
				} else {
					return false;
				}
			break;
			default:
				return false;
			break;
		}
	};

  /**
	 * イベント開催日日付表記を返却
	 * @param  {String} aStartDate  - 企画実施開始日
	 * @param  {String} aEndDate    - 企画実施終了日
	 * @return {String} aResuleDate - 表示用文字列
	 */
	STORE.UTIL.convRenewDispDate = (aStartDate, aEndDate)=> {
		let convStartDate = aStartDate ? aStartDate.replace(/(\d{4})(\d{2})(\d{2})/, '$1.$2.$3') : '';
		let convEndDate = aEndDate ? aEndDate.replace(/(\d{4})(\d{2})(\d{2})/, '$1.$2.$3') : '';
		let aResuleDate = '';

		if(convEndDate.replace(/\./g, '') === STORE.CONS.EVENT_MAX_END_DATE_STR) {
			convEndDate = '';
		}

		if(convStartDate != '' || convEndDate != '') {
			aResuleDate = convStartDate.replace(/\.0/g, '.') + ' 〜 ' + convEndDate.replace(/\.0/g, '.');
		}
		return aResuleDate;
	};

  /**
	 * 記事開始日と更新日を比較して新しい数値の日付を返却し変換
	 * @param  {Number} aUpdate			- 記事更新日
	 * @param  {Number} aStartDate		- 記事開始日
	 * @return {String} aResultDateStr 	- 結果日付文字列
	 */
  STORE.UTIL.compareUpdateArticle = (aUpdate, aStartDate)=> {
    let forCompareUpdate	= aUpdate.replace(/^(\d{8}).*/, '$1');
    let updateHHMMSS		= aUpdate.replace(/.*(\d{6})$/, '$1');
    if(Number(forCompareUpdate) > Number(aStartDate)) {
      return aUpdate;
    } else if(Number(forCompareUpdate) < Number(aStartDate)) {
      return aStartDate + updateHHMMSS;
    } else {
      return aUpdate;
    }
  };

  /**
   * 更新日数値文字列をもとに画面に表示する日付形式に変換
   * @param  {String} aTargetDate - 更新日数値文字列
   * @return {String}             - 画面出力する日付文字列
   */
  STORE.UTIL.getDispUpdate = (aTargetDate)=> {
    let yyyy = aTargetDate.replace(/^(\d{4}).*/, '$1');
    let mm   = aTargetDate.replace(/^\d{4}(\d{2}).*/, '$1').replace(/^0(\d{1})/, '$1');
    let dd   = aTargetDate.replace(/^\d{4}\d{2}(\d{2}).*/, '$1').replace(/^0(\d{1})/, '$1');

    return `${yyyy}.${mm}.${dd}`;
  };

  /**
	 * 記事更新日文字列をもとにページ表示用文字列へ変換
	 * @param  {String} aUpdate	- 記事更新日文字列(yyyymmddhhmmss)
	 * @return {String}			- ページ表示用文字列(yy.mm.dd)
	 */
	STORE.UTIL.convUpdateDisp = (aUpdate)=> {
		return aUpdate
				.replace(/^\d{2}(\d{2})(\d{2})(\d{2}).*/, '$1.$2.$3')
				.replace(/\.0/g,'.');
	};

  /**
	 * yyyymmdd形式をyy.mm.ddに変換し返却
	 * @param  {String} aDate - 対象日付文字列
	 * @return {String} convDate    - 変換済み文字列
	 */
	STORE.UTIL.convEnDate = (aDate)=> {
		if(typeof aDate === 'undefined') return '';
		if(/^9999.*/.test(aDate)) return '';
		if(!aDate) return '';

		let yy		= aDate.replace(/^\d{2}(\d{2}).*/, '$1');
		let mm			= aDate.replace(/^\d{4}(\d{2}).*/, '$1');
		let dd			= aDate.replace(/^\d{6}(\d{2}).*/, '$1');
		let result;

		result			= `${yy}.${mm}.${dd}`.replace(/\.0(\d)/g, '.$1');
		return result;
	};

  /**
	 * 日付文字列を和式に変換し曜日を追加 mm月dd日(w)
	 * @param  {String} aDate	- 対象日付文字列
	 * @return {String}			- 変換済み文字列
	 */
	STORE.UTIL.convJpDate = (aDate)=> {
		if(typeof aDate === 'undefined' || !aDate) return false;
		if(/^9999.*/.test(aDate)) return '';

		let yyyy		= aDate.replace(/^(\d{4}).*/, '$1');
		let mm			= aDate.replace(/^\d{4}(\d{2}).*/, '$1');
		let dd			= aDate.replace(/^\d{6}(\d{2}).*/, '$1');
		let weekAry		= ['日', '月', '火', '水', '木', '金', '土'];
		let convDate	= new Date(`${yyyy}/${mm}/${dd}`);
		let resultWeek	= weekAry[convDate.getDay()];
		let result;


		result			= `${mm}月${dd}日(${resultWeek})`.replace(/0(\d)/g, '$1');
		return result;
	};

  /**
	 * 日付文字列を和式に変換し曜日を追加 yy年mm月dd日(w)
	 * @param  {String} aDate	- 対象日付文字列
	 * @return {String}			- 変換済み文字列
	 */
	STORE.UTIL.convJpDateAddYear = (aDate)=> {
		if(typeof aDate === 'undefined') return false;
		if(/^9999.*/.test(aDate)) return '';

		let yyyy		= aDate.replace(/^(\d{4}).*/, '$1');
		let mm			= aDate.replace(/^\d{4}(\d{2}).*/, '$1');
		let dd			= aDate.replace(/^\d{6}(\d{2}).*/, '$1');
		let weekAry		= ['日', '月', '火', '水', '木', '金', '土'];
		let convDate	= new Date(`${yyyy}/${mm}/${dd}`);
		let resultWeek	= weekAry[convDate.getDay()];
		let outputYy	= yyyy.replace(/^\d{2}(\d{2})/, '$1');
		let result;

		result			= `${outputYy}年${mm}月${dd}日(${resultWeek})`.replace(/0(\d)/g, '$1');
		return result;
	};

  /**
   * 取得データのHTML出力
   * @param {String} aOutputElem - 出力先エレメント文字列
   * @param {String} aTmplElem   - テンプレートエレメントID文字列
   * @param {Array || Object} aOutputData - 出力データ
   */
  STORE.UTIL.outputHtml = (aOutputElem, aTmplElem, aOutputData)=> {
    let outputHtml = $(aTmplElem).render(aOutputData);
    $(aOutputElem).html(outputHtml);
  };

  /**
   * 取得データのHTML追加出力
   * @param {String} aOutputElem - 出力先エレメント文字列
   * @param {String} aTmplElem   - テンプレートエレメントID文字列
   * @param {Array || Object} aOutputData - 出力データ
   */
  STORE.UTIL.appendHtml = (aOutputElem, aTmplElem, aOutputData)=> {
    let outputHtml = $(aTmplElem).render(aOutputData);
    $(aOutputElem).append(outputHtml);
  };

  /**
	 * 現在日文字列（yyyymmdd）を取得
	 * @return {String} -現在日文字列
	 */
	STORE.UTIL.getTodayStr = ()=> {
		let today	= new Date();
		let yyyy	= today.getUTCFullYear();
		let mm		= today.getMonth() + 1;
		let dd		= today.getDate();

		return `${yyyy}${mm}${dd}`;
	};

	/**
	 * 現在日文字列（yyyymmdd）を取得
	 * @return {String} -現在日文字列
	 */
	STORE.UTIL.getTodayTimeStr = ()=> {
		let today = new Date();
		let yyyy = today.getFullYear();
		let mm = String(today.getMonth() + 1).padStart(2, '0'); // 月が一桁の場合、先頭に '0' を追加
		let dd = String(today.getDate()).padStart(2, '0'); // 日が一桁の場合、先頭に '0' を追加
		let hh = String(today.getHours()).padStart(2, '0'); // 時が一桁の場合、先頭に '0' を追加
		let min = String(today.getMinutes()).padStart(2, '0'); // 分が一桁の場合、先頭に '0' を追加
		let ss = String(today.getSeconds()).padStart(2, '0'); // 秒が一桁の場合、先頭に '0' を追加

		return `${yyyy}${mm}${dd}${hh}${min}${ss}`;
	};

	/**
	 * 日付文字列(yyyymmdd)から月、日の0埋め解除
	 * @param  {String} aDateStr	- 日付文字列
	 * @return {String}				- 変換済み文字列
	 */
	STORE.UTIL.convDateStrDelZeroPadding = (aDateStr)=> {
		let strYear		= aDateStr.replace(/^(\d{4}).*/, '$1');
		let strMonth	= aDateStr.replace(/^\d{4}(\d{2}).*/, '$1').replace(/^0/, '');
		let strDate		= aDateStr.replace(/.*(\d{2})$/, '$1').replace(/^0/, '');

		return `${strYear}${strMonth}${strDate}`;
	};


	/**
	 * 現在日付から時・分・秒を切り捨てた時間を取得
	 * @return {Number} - 現在日の時間数値
	 */
	STORE.UTIL.getTodayTimeNumber = () => {
		let today	= new Date();
		let yyyy	= today.getFullYear();
		let mm		= today.getMonth() + 1;
		let dd		= today.getDate();

		return new Date(`${yyyy}/${mm}/${dd}`).getTime();
	};

	/**
	 * 引数 日付文字列（yyyymmdd）から日付変換し、
	 * 時間数値へ変換し返却
	 * @param  {String} aDate	- 対象日付文字列
	 * @return {Number}			- 変換済み日付数値
	 */
	STORE.UTIL.getSetTimeNumber = (aDate)=> {
		let convDateStr = aDate.replace(/^(\d{4})(\d{2})(\d{2})$/, '$1/$2/$3');
		return new Date(convDateStr).getTime();
	};

  /**
	 * 引数がオブジェクトの場合、配列を生成して引数オブジェクトを
	 * 配列に挿入
	 * @param  {Object || Array} aTestData	- 判定データ
	 * @return {Array}						- 変換済みデータ
	 */
	STORE.UTIL.convObjInArray = (aTestData)=> {
		let wrapAry	= [];
		if(aTestData instanceof Array) {
			return aTestData;
		} else {
			wrapAry.push(aTestData);
			return wrapAry;
		}
	};

	/**
	 * URLにパラメータを付与
	 * @param  {String} path	- 追加元のURL文字列
	 * @param  {String} key		- 追加するパラメータのキーの名称
	 * @param  {String} value	- 追加するパラメータの値
	 * @param  {Boolean} save	- 上書きするかどうか
	 * @return {String} result	- パラメータ付与文字列
	 */
	STORE.UTIL.addUrlParam = (path, key, value, save)=> {
		let result = '';

		if (path && key && value) {
			let
				addParam		= key + '=' + value,
				paths			= path.split('/'),
				fullFileName	= paths.pop(),
				fileName		= fullFileName.replace(/^(.*?)[\?#].*/, '$1'),
				dirName			= path.replace(fullFileName, ''),
				hashMatches		= fullFileName.match(/#([^#]+)$/),
				paramMatches	= fullFileName.match(/\?([^\?]+)$/),
				hash			= '',
				param			= '',
				params			= [],
				fullPath		= '',
				hitParamIndex	= -1;

			if (hashMatches && hashMatches[1]) {
				hash = hashMatches[1];
			}

			if (paramMatches && paramMatches[1]) {
				param = paramMatches[1].replace(/#[^#]+$/g, '').replace('&', '&');
			}

			fullPath = dirName + fileName;

			if (param === '') {
				param = addParam;
			} else if (save) {
				params = param.split('&');

				for (var i = 0, len = params.length; i < len; i++) {
					if (params[i].match(new RegExp('^' + key + '='))) {
						hitParamIndex = i;
						break;
					}
				}
				if (hitParamIndex > -1) {
					params[hitParamIndex] = addParam;
					param = params.join('&');
				} else {
					param += '&' + addParam;
				}
			} else {
				param += '&' + addParam;
			}
			fullPath += '?' + param;
			if (hash !== '') {
				fullPath += '#' + hash;
			}
			result = fullPath;
		}
		result.replace(/\r?\n/g, '');
		return result;
	};


  /**
	 * 開催期間中のイベントか判定
	 * @param  {String}	aStartDate	- 企画実施開始日
	 * @param  {String} aEndData	- 企画実施終了日
	 * @return {Boolean}			- 開催期間中イベントの場合はtrue
	 */
	STORE.UTIL.checkCurrentEvent = (aStartDate, aEndData)=> {
    let isNotStart		=  !aStartDate;
		let isNotEnd		= !aEndData;
		let todayDateNum	= STORE.UTIL.getTodayTimeNumber();
		let convStartDate, convEndDate;

		if(isNotStart && isNotEnd) {
			return;
		} else if(isNotStart) {
			convStartDate	= STORE.UTIL.getTodayTimeNumber();
			convEndDate		= STORE.UTIL.getSetTimeNumber(aEndData);
		} else if(isNotEnd) {
			convStartDate	= STORE.UTIL.getSetTimeNumber(aStartDate);
			convEndDate		= STORE.UTIL.getSetTimeNumber(STORE.CONS.EVENT_MAX_END_DATE_STR);
		} else {
			convStartDate	= STORE.UTIL.getSetTimeNumber(aStartDate);
			convEndDate		= STORE.UTIL.getSetTimeNumber(aEndData);
		}

		if( convStartDate <= todayDateNum && todayDateNum <= convEndDate ) {
			return true;
		} else {
			return false;
		}

	};

  /**
	 * 未来のイベントか判定
	 * @param  {String}	aStartDate	- 企画実施開始日
	 * @param  {String} aEndData	- 企画実施終了日
	 * @return {Boolean}			- 未来イベントの場合はtrue
	 */
	STORE.UTIL.checkFutureEvent = (aStartDate, aEndData)=> {
		let isNotStart		= !aStartDate;
		let isNotEnd		= !aEndData;
		let todayDateNum	= STORE.UTIL.getTodayTimeNumber();
		let convStartDate, convEndDate;

		if(isNotStart && isNotEnd) {
			return;
		} else if(isNotStart) {
			convStartDate	= STORE.UTIL.getTodayTimeNumber();
			convEndDate		= STORE.UTIL.getSetTimeNumber(aEndData);
		} else if(isNotEnd) {
			convStartDate	= STORE.UTIL.getSetTimeNumber(aStartDate);
			convEndDate		= STORE.UTIL.getSetTimeNumber(STORE.CONS.EVENT_MAX_END_DATE_STR);
		} else {
			convStartDate	= STORE.UTIL.getSetTimeNumber(aStartDate);
			convEndDate		= STORE.UTIL.getSetTimeNumber(aEndData);
		}

		if(todayDateNum < convStartDate) {
			return true;
		} else {
			return false;
		}

	};

	/**
	 * 店舗TOP イベント　ソート処理
	 * - 開催日対象記事 > 未来開催記事
	 * @param  {Object} a	- 比較対象A
	 * @param  {Object}	b	- 比較対象B
	 * @return {Array}		- ソート済み配列
	 */
	STORE.UTIL.sortStoreTopEvent = (a, b)=> {
		let aFutureFlagNum	= a.isFutureEventFlag ? 1 : 0;
		let bFutureFlagNum	= b.isFutureEventFlag ? 1 : 0;

		// 現在イベント > 未来イベント
		if(aFutureFlagNum < bFutureFlagNum) return -1;
		if(aFutureFlagNum > bFutureFlagNum) return 1;

		// 未来イベントは企画実施開始日の昇順
		if(a.isFutureEventFlag && b.isFutureEventFlag) {
			if(a.sortDate < b.sortDate) return -1;
			if(a.sortDate > b.sortDate) return 1;
		}

		// 現在イベントは更新日の降順
		if( a.update > b.update ) return -1;
		if( a.update < b.update ) return 1;

		return 0;
	};

  /**
     * 特集付属記事　ソート処理
     * # Condtion
     * # フェア、イベントのみ企画実施開始日が
     * # 未来日のものは後ろにソート
     * @param  {Object} a	- 比較対象A
     * @param  {Object}	b	- 比較対象B
     * @return {Array}		- ソート済み配列
     */
  STORE.UTIL.sortFeatureSubArticles = (a, b)=> {
    let aSort = Number(a.update);
    let bSort = Number(b.update);
    let aIsFuture = a.isFuture;
    let bIsFuture = b.isFuture;

    if(aIsFuture < bIsFuture) return -1;
    if(aIsFuture > bIsFuture) return 1;

    if( aSort > bSort ) return -1;
    if( aSort < bSort ) return 1;

    return 0;
  };

  /**
	 * 有効なMediaQueryを監視し対象端末文字列を返却
	 * @return  {String}	- PC => 'pc' SP => 'sp'
	 */
	STORE.UTIL.getMQDevice = ()=> {
		let pcCond = window.matchMedia('screen and (min-width:768px)');
		let spCond = window.matchMedia('screen and (max-width:767px)');

		if(pcCond.matches) {
			return 'pc';
		} else {
			return 'sp';
		}
	};

	/**
 * UserAgentから閲覧端末情報を取得
 * @return  {String}	- PC => 'pc' SP => 'sp'
 */
	STORE.UTIL.getDeviceUa = ()=> {
		const ua = navigator.userAgent.toLowerCase();
		const condRegAry = [
			/iphone/,
			/android/
		];
		let spFlag = false;
		_.some(condRegAry, (aReg) => {
			if(aReg.test(ua)) {
				spFlag = true;
				return true;
			}
		});
		if(spFlag) {
			return 'sp';
		} else {
			return 'pc';
		}
	};


  /**
	 * 指定した施設情報区分の本文を取得
	 * @param  {Object} aDataObj	- 施設情報オブジェクト
	 * @param  {String} aClass	- 取得するクラス文字列
	 * @param  {Function} aFunc	- 取得条件関数
	 * @return {String}			- 抽出結果
	 */
	STORE.UTIL.getFacilityInfoClassText = (aDataObj, aClass, aFunc)=> {
		let isInfoList = aDataObj.facility_info_list != null;
		let infoList = isInfoList ? aDataObj.facility_info_list.facility_info : false;
		let result;

		if(!isInfoList) {
			infoList = [];
		} else {
			infoList = aDataObj.facility_info_list.facility_info;
		}

		_.some(infoList, (aItem)=> {
			if(aItem.facility_info_class === aClass) {
				if(aFunc(aItem.title)) {
					result = STORE.UTIL.getStrDelParagraph(aItem.text);
					// result = aItem.text;
					return true;
				}
			}
		});

		return result;
	};

	/**
	 * 施設情報の電話番号を抽出
	 * @param {String} aFacilityTelText - TTS登録電話番号　文字列
	 * @param {String}					- 電話番号文字列
	 */
	STORE.UTIL.getFacilityTelNum = (aFacilityTelText)=> {
		return aFacilityTelText
			.replace(/.*data-tel="(.*?)".*/, '$1')
			.replace(/(\(|\))/g, '-');
	};

	/**
	 * リンク用電話番号文字列を取得
	 * @param  {String} aTelNum	- 電話番号文字列
	 * @return {String}			- ハイフン、括弧を取り除いた電話番号文字列
	 */
	STORE.UTIL.getCallLinkNumber = (aTelNum)=> {
		return STORE.UTIL.convert_zen2han(aTelNum)
			.replace(/(\(|\)|-)/g, '');
	};

	/**
	 * 付帯施設情報のテキスト文字列からピクト画像名を返却
	 * @param  {Stirng} aFacilityTitle	- 付帯施設文字列
	 * @return {String} resultFileName	- 出力ファイル名
	 */
	STORE.UTIL.getFacilityPict = (aFacilityTitle)=> {
		let convText = aFacilityTitle.replace(/\s/g, '');
		let pictNumStr, resultFileName;
		_.some(STORE.CONS.FACILITY_PICT, (aNum, aPict)=> {
			if(aFacilityTitle.indexOf(aPict) !== -1) {
				resultFileName = `ico_institution_${aNum}.gif`;
				return true;
			}
		});
		if(!resultFileName) { return false}
		return resultFileName;
	};

  /**
	 * 施設情報からフロア文字列を抽出し返却
	 * @param  {String} aFacilityText	- 施設情報文字列
	 * @return {String}					- 抽出済みテキスト
	 */
	STORE.UTIL.getFacilityFloor = (aFacilityText)=> {
		// すべての【】で囲まれた部分を抽出
		let matches = aFacilityText.match(/【(.*?)】/g);
		if(!matches || matches.length === 0) {
			return '';
		}
		
		// フロア情報のパターン（完全一致用）
		// パターン: 数字+F, B+数字+F, B+数字（Fなし）, 地下+数字+F, RF, 数字+階, 屋上, 全フロアなど（半角・全角両対応）
		let floorPattern = /^(?:[BｂＢ]?[0-9０-９]+[FｆＦ]|[BｂＢ][0-9０-９]+|地下[0-9０-９]+[FｆＦ]|[RｒＲ][FｆＦ]|[BｂＢ]?[0-9０-９]+階|[RｒＲ]階|屋上|全フロア)$/;
		
		// フロア情報のパターン（部分一致用：説明文が続く場合にも対応）
		let floorPatternPartial = /[BｂＢ]?[0-9０-９]+[FｆＦ階]|[BｂＢ][0-9０-９]+|地下[0-9０-９]+[FｆＦ階]|[RｒＲ][FｆＦ階]|屋上|全フロア/;
		
		// フロア情報として扱う追加キーワード（フロア番号を含まない場合でもフロア情報として扱う）
		let additionalFloorKeywords = ['貸出', 'カウンター', '受付', '案内', 'インフォメーション', 'サービス', 'コーナー', 'フロア'];
		
		let allFloors = [];
		
		// 各【】で囲まれた部分を処理
		matches.forEach(match => {
			// 【】を除去して中身を取得
			let content = match.replace(/【(.*?)】/, '$1').trim();
			
			// フロア情報が含まれているかチェック
			// 1. 既存のフロアパターンに一致するか
			// 2. 追加キーワードを含むか
			let isFloorInfo = floorPatternPartial.test(content) || 
				additionalFloorKeywords.some(keyword => content.indexOf(keyword) !== -1);
			
			if(!isFloorInfo) {
				return; // フロア情報が含まれていない場合はスキップ
			}
			
			// 「全フロア」が含まれている場合は、説明文があってもそのまま全体を使用
			if(/全フロア/.test(content)) {
				allFloors.push(content);
				return;
			}
			
			// 追加キーワードを含むが、既存のフロアパターンに一致しない場合
			// → そのまま全体を使用（例：ベビカル貸出場所）
			let hasAdditionalKeyword = additionalFloorKeywords.some(keyword => content.indexOf(keyword) !== -1);
			if(hasAdditionalKeyword && !floorPatternPartial.test(content)) {
				allFloors.push(content);
				return;
			}
			
			// 「・」で分割
			let floorParts = content.split('・').map(part => part.trim());
			
			// すべての要素がフロアパターンに完全一致するかチェック
			let allMatchPattern = floorParts.every(part => floorPattern.test(part));
			
			if(allMatchPattern) {
				// すべての要素がフロアパターンに一致する場合
				// → 各要素を個別に追加（ソート可能にするため）
				floorParts.forEach(part => {
					if(floorPattern.test(part)) {
						allFloors.push(part);
					}
				});
			} else {
				// 一部の要素に説明文が含まれている場合
				// → そのまま全体を使用（例：4F・5Fカメラのキタムラ内）
				allFloors.push(content);
			}
		});
		
		if(allFloors.length === 0) {
			return '';
		}
		
		// 重複を除去
		let uniqueFloors = [...new Set(allFloors)];
		
		// フロアを数値に変換してソートする関数
		let getFloorSortValue = (floor) => {
			// 全角を半角に変換（比較用）
			let normalizedFloor = floor.replace(/[０-９ＢＦｂｆ]/g, (char) => {
				const map = {
					'０': '0', '１': '1', '２': '2', '３': '3', '４': '4',
					'５': '5', '６': '6', '７': '7', '８': '8', '９': '9',
					'Ｂ': 'B', 'Ｆ': 'F', 'ｂ': 'b', 'ｆ': 'f'
				};
				return map[char] || char;
			});
			
			// 「全フロア」が含まれている場合は最上位として扱う
			if(/全フロア/.test(normalizedFloor)) {
				return 10000;
			}
			
			// 最初のフロア情報を抽出（説明文が含まれている場合にも対応）
			// 例：4F・5Fカメラのキタムラ内 → 4Fを抽出
			// B2, B1などのFが付かないパターンにも対応
			let firstFloorMatch = normalizedFloor.match(/^([Bb]?\d+[Ff階]|[Bb]\d+|地下\d+[Ff階]|[Rr][Ff階]|屋上)/);
			if(firstFloorMatch) {
				let firstFloor = firstFloorMatch[1];
				
				// RF（屋上）または「屋上」は最大値として扱う
				if(/^[Rr][Ff階]?$/.test(firstFloor) || firstFloor === '屋上') {
					return 9999;
				}
				
				// B1F, B2F, B1, B2または地下1F, 地下2Fなどの地下階（負の数として扱う）
				// B+数字（Fや階が付かない場合も含む）
				let basementMatch = firstFloor.match(/^[Bb](\d+)([Ff階]?)$/);
				if(basementMatch) {
					return -parseInt(basementMatch[1], 10);
				}
				
				// 地下1F, 地下2Fなどの地下階（負の数として扱う）
				let chikaMatch = firstFloor.match(/^地下(\d+)[Ff階]?$/);
				if(chikaMatch) {
					return -parseInt(chikaMatch[1], 10);
				}
				
				// 1F, 2Fなどの地上階（正の数として扱う）
				let floorMatch = firstFloor.match(/^(\d+)[Ff階]?$/);
				if(floorMatch) {
					return parseInt(floorMatch[1], 10);
				}
			}
			
			// 追加キーワードを含むが、フロア番号が含まれていない場合
			// → 通常のフロア番号より後、RF・屋上より前の位置に配置
			let additionalKeywords = ['貸出', 'カウンター', '受付', '案内', 'インフォメーション', 'サービス', 'コーナー', 'フロア'];
			if(additionalKeywords.some(keyword => normalizedFloor.indexOf(keyword) !== -1)) {
				return 5000;
			}
			
			// パターンに一致しない場合は0
			return 0;
		};
		
		// ソート（数値順）
		uniqueFloors.sort((a, b) => {
			return getFloorSortValue(a) - getFloorSortValue(b);
		});
		
		return uniqueFloors.join('・');
	};

	/**
	 * 施設情報からフロア説明文を抽出し返却
	 * @param  {String} aFacilityText	- 施設情報文字列
	 * @return {String}					- 抽出済みテキスト
	 */
	STORE.UTIL.getFacilityText = (aFacilityText)=> {
		return aFacilityText
			.replace(/^【.*?】$/, '')
			.replace(/.*?【.*?】.*?<br\/>(.*?)/, '$1');
	};

  /**
	 * [ショップガイド] フロアから探す　フロアタイトルを抽出し返却
	 * @param  {Array || Object}	aFloorTitleList	- フロアタイトルリスト
	 * @return {String}				result			- 抽出済み文字列
	 */
	STORE.UTIL.getFloorTitle = (aFloorTitleList)=> {
		let convFloorList	= STORE.UTIL.convObjInArray(aFloorTitleList);
		let result			= '';

		// 文字列変換前にソート処理
		convFloorList.sort(STORE.UTIL.sortFloorTitle);

		_.each(convFloorList, (aFloorTitle, idx)=> {
			if(idx === 0) {
				result += aFloorTitle.floor_title;
			} else {
				result += `/${aFloorTitle.floor_title}`;
			}
		});
		return result;
	};

  /**
	 * 翻訳時にショップ名称を英語表記へ変更
	 * @param  {String} aShopNameJp - ショップ名称（日本語）
	 * @param  {String} aShopNameEn	- ショップ名称（英語）
	 */
	STORE.UTIL.getShopNameTranser = (aShopNameJp, aShopNameEn)=> {
		if(typeof aShopNameEn !== 'undefined' && STORE.UTIL.getTranserLang() !== STORE.CONS.TRANSER_JP) {
			return aShopNameEn;
		} else {
			return aShopNameJp;
		}
	};

  /**
	 * 現在のURLから翻訳言語の識別文字列を返却
	 * @return  {String} result	- 翻訳識別文字列
	 */
	STORE.UTIL.getTranserLang = () => {
		let currentDomain		= location.hostname;
		let urlQueryParam		= STORE.UTIL.getUrlQueryParam();
		let targetQueryParam	= 'transer';
		let result;

		_.some(STORE.CONS.TRANSER_DOMAIN_MASTER, (aCond, aLang) => {
			if(aCond.test(currentDomain)) {
				result = aLang;
				return true;
			}
		});

		if(!result) {
			if(typeof urlQueryParam[targetQueryParam] !== 'undefined') {
				result = urlQueryParam[targetQueryParam];
			} else {
				result = 'jp';
			}
		}

		return result;
	};

  /**
	 * ショップ紹介ページへのリンクURL生成
	 * @param  {String} aStcd		- 店舗番号
	 * @param  {String} aShopSeq	- ショップ連番
	 * @return {String} resultUrl	- 生成URL
	 */
	STORE.UTIL.makeShopIntroLinkUrl = (aStcd, aShopSeq)=> {
		return `/${aStcd}/shop-guide/shop-detail.html?shop_id=${aShopSeq}`;
	};

  /**
	 * 金額にカンマを付与
	 * @param  {Number} aPrice	- 金額
	 * @return {String}			- カンマ付与価格文字列
	 */
	STORE.UTIL.getCommaPrice = (aPrice)=> {
		return String(aPrice).replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
	};

  /**
	 * ショップカテゴリー名称を取得
	 * @param  {Object} aCategoryObj	- カテゴリー情報格納オブジェクト
	 * @return {String} 				- カテゴリー名称
	 */
	STORE.UTIL.getShopCategory = (aCategoryObj)=> {
		return aCategoryObj.shop_category.shop_category_name;
	};

	/**
	 * ショップカテゴリー連番を取得
	 * @param  {Object} aCategoryObj	- カテゴリー情報格納オブジェクト
	 * @return {String} 				- カテゴリー連番
	 */
	STORE.UTIL.getShopCategorySeq = (aCategoryObj)=> {
		return aCategoryObj.shop_category.shop_category_seq;
	};

	/**
	 * オブジェクトか配列判定し、配列へ格納
	 * @param {Object|| Array} aTargetData - 変換対象データ
	 * @return {Array}           result       - 結果データ
	 */
	STORE.UTIL.convObject2Ary = (aTargetData)=> {
		let result = [];

		if( !(aTargetData instanceof Array) && aTargetData instanceof Object ) {
			result.push(aTargetData);
		} else {
			result = aTargetData;
		}

		return result;

	};

	/**
	 * ハッシュタグデータを取得
	 * @param  {Object || Array} aHashtagData - TTSハッシュタグ
	 * @return {Array}           result       - 結果データ
	 */
	STORE.UTIL.getHashTagData = (aHashtagData)=> {
		let result = [];
		if(!aHashtagData) {
			return false;
		}

    if( !(aHashtagData instanceof Array) && aHashtagData instanceof Object ) {
			result.push(aHashtagData);
		}

		if( aHashtagData instanceof Array && aHashtagData instanceof Object ) {
			_.each(aHashtagData, (aHashTag)=> {
				result.push(aHashTag);
			});
			result.sort((a, b)=> {
				if (Number(a.display_seq) > Number(b.display_seq)) {
					return 1;
				} else {
					return -1;
				}
			});
		}

		return result;
	};

	/**
	 * ネット通販リンクURLが公式か判定
	 * @param  {String} aUrl	- 投稿URL
	 * @return {String}			- 公式URLではない場合は空白を返却
	 */
	STORE.UTIL.checkWcLinkUrl = (aUrl)=> {
		let result;
		_.some(STORE.CONS.EC_SITE_URL_ARY, (aUrlRegExp)=> {
			if(aUrlRegExp.test(aUrl)) {
				result = aUrl;
				return true;
			}
		});
		return result;
	};

  /**
	 * 価格情報から表示用価格文字列を返却
	 * @param  {String} aPriceClass	- 価格表記区分
	 * @param  {String}	aPrice1		- 価格1
	 * @param  {String} aPrice2		- 価格2
	 * @return {String || Boolean} resultPrice	- 表示価格文字列
	 */
	STORE.UTIL.getDisplayPrice = (aPriceClass, aPrice1, aPrice2)=> {
		// let notSetPrice 	= typeof aPrice1 === 'undefined' && typeof aPrice2 === 'undefined';
		let notSetPrice 	= !aPrice1 && !aPrice2;
		let addPriceHead	= '税込：';
		let addPriceFoot	= '円';
		let jointPrice		= '～';
		let addCommaPrice1, addCommaPrice2, result;
		if(notSetPrice) return false;

		switch(aPriceClass) {
			case '01':
				addCommaPrice1	= addPriceHead + STORE.UTIL.getCommaPrice(aPrice1) + addPriceFoot;
				result			= addCommaPrice1;
			break;

			case '02':
				addCommaPrice1	= addPriceHead + STORE.UTIL.getCommaPrice(aPrice1) + addPriceFoot;
				result			= addCommaPrice1 + jointPrice;
			break;

			case '03':
				addCommaPrice1	= addPriceHead + STORE.UTIL.getCommaPrice(aPrice1) + addPriceFoot;
				addCommaPrice2	= addPriceHead + STORE.UTIL.getCommaPrice(aPrice2) + addPriceFoot;
				result			= addCommaPrice1 + jointPrice + addCommaPrice2;
			break;

			case '04':
				addCommaPrice2	= addPriceHead + STORE.UTIL.getCommaPrice(aPrice2) + addPriceFoot;
				result			= jointPrice + addCommaPrice2;
			break;
		}

		return result;
	};

	/**
	 * 有効なMediaQueryを監視し対象端末文字列を返却
	 * @return  {String}	- PC => 'pc' SP => 'sp'
	 */
	STORE.UTIL.getMQDevice = ()=> {
		let pcCond = window.matchMedia('screen and (min-width:768px)');
		let spCond = window.matchMedia('screen and (max-width:767px)');

		if(pcCond.matches) {
			return 'pc';
		} else {
			return 'sp';
		}
	};

	/**
	 * [jsRender]テンプレート出力
	 * @param  {String} aTemplateId        - テンプレートIDセレクター
	 * @param  {String} aOutputElem        - 出力エレメントセレクター
	 * @param  {Array||Object} aOutputData - 出力データ
	 */
	STORE.UTIL.outputHtmlTemplate = (aTemplateId, aOutputElem, aOutputData)=> {
		let outputHtml = '';
		outputHtml = $(aTemplateId).render(aOutputData);
		$(aOutputElem).html(outputHtml);
	};

  /**
   * バナーソート処理
   * @param  {Object} a	- 比較対象A
   * @param  {Object}	b	- 比較対象B
   * @return {Array}		- ソート済み配列
   */
  STORE.UTIL.sortBnrList = function (a, b) {
    if (a.sort < b.sort) return -1;
    if (a.sort > b.sort) return 1;
    return 0;
  };

  /**
	 * お店からのお知らせ、ショップニュース、イベント、クーポン
	 * ソート処理[降順]
	 * @param  {Object} a	- 比較対象A
	 * @param  {Object}	b	- 比較対象B
	 * @return {Array}		- ソート済み配列
	 */
	STORE.UTIL.sortCommonArticleList = (a, b)=> {
		let aSort = Number(a.update);
		let bSort = Number(b.update);

		if( aSort > bSort ) return -1;
		if( aSort < bSort ) return 1;
		return 0;
	};

  /**
	 * ショップガイド ショップ　ソート処理
	 * @param  {Object} a	- 比較対象A
	 * @param  {Object}	b	- 比較対象B
	 */
	STORE.UTIL.sortShopGuideShop = (a, b)=> {
		let aSort = a.kanaName;
		let bSort = b.kanaName;

		if( aSort < bSort ) return -1;
		if( aSort > bSort ) return 1;
		return 0;
	};

  /**
	 * URLから対象のパラメータ値を取得
	 * @param  {String} aParamKey	- 対象のパラメーターキー
	 * @return {String}	result		- 取得済みパラメータ値
	 */
	STORE.UTIL.getParamFromUrl = (aParamKey)=> {
		let convUrlParam = STORE.UTIL.getUrlQueryParam();
		let result;
		_.some(convUrlParam, (aValue, aKey)=> {
			if(aParamKey === aKey) {
				result = aValue;
				return true;
			}
		});
		return result;
	};

  /**
	 * URLのクエリパラメータを連想配列化し返却
	 * @return  {Object} result	- 取得済みデータ
	 */
	STORE.UTIL.getUrlQueryParam = () => {
		let result	= {};
		let param	= location.search.substring(1).split('&');
		for(let i = 0; param[i]; i++) {
			if(param[i].indexOf('=') != -1) {
				let kv	= param[i].split('=');
				result[kv[0]] = STORE.UTIL.convSanitizingValue(kv[1]);
			} else {
				let kv	= param[i];
				result[kv[0]];
			}
		};
		return result;
	};

  /**
	 * URLパラメータ取得時のサニタイジング
	 * @param  {String} aParamValue	- パラメータの値
	 * @return {String}				- 変換済み文字列
	 */
	STORE.UTIL.convSanitizingValue = (aParamValue)=> {
		return aParamValue.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
	};

  /**
	 * 	URL文字列に任意のパラメータを付与する
	 * @param   {String}  path   - 追加するURL文字列
	 * @param   {Stirng}  key    - 追加するパラメータキー
	 * @param   {Sting}   value  - 追加するパラメータ値
	 * @param   {Boolean} save   - 同一キーが存在する場合　上書き-> true 、追加 -> false
	 * @return  {String}  result - クエリパラメータ付与済み文字列
	 */
	STORE.UTIL.addUrlParam = (path, key, value, save) => {
		let result = '';
		if (path && key && value) {
			let addParam		= key + '=' + value,
			paths				= path.split('/'),
			fullFileName		= paths.pop(),
			fileName			= fullFileName.replace(/^(.*?)[\?#].*/, '$1'),
			dirName				= path.replace(fullFileName, ''),
			hashMatches			= fullFileName.match(/#([^#]+)$/),
			paramMatches		= fullFileName.match(/\?([^\?]+)$/),
			hash				= '',
			param				= '',
			params				= [],
			fullPath			= '',
			hitParamIndex		= -1;
			if (hashMatches && hashMatches[1]) { hash = hashMatches[1]; }
			if (paramMatches && paramMatches[1]) { param = paramMatches[1].replace(/#[^#]+$/g, '').replace('&', '&');}
			fullPath = dirName + fileName;
			if (param === '') {
				param = addParam;
			} else if (save) {
				params = param.split('&');
				for (let i = 0, len = params.length; i < len; i++) {
					if (params[i].match(new RegExp('^' + key + '='))) {
						hitParamIndex = i;
						break;
					}
				}
				if (hitParamIndex > -1) {
					params[hitParamIndex] = addParam;
					param = params.join('&');
				} else { param += '&' + addParam; }
			} else { param += '&' + addParam; }
			fullPath += '?' + param;
			if (hash !== '') { fullPath += '#' + hash; }
			result = fullPath;
    }
    return result;
  };

  /**
	 * imgデータ参照時、リリースドメイン以外は
	 * 外部ファイル取得用のパスへ変換
	 * @param  {String} aImgPath	- 画像のパス
	 * @return {String}				- 変換済みのパス
	 */
	/*
  STORE.UTIL.imgDataPath	= (aImgPath)=> {
		const currentDomain = location.hostname;
		let result;

		if(typeof aImgPath === 'undefined') {
			return;
		}
		_.some(STORE.CONS.PROD_DOMAINS, (aDomain) => {
			if(aDomain === currentDomain) {
				result = aImgPath;
				return true;
			}
		})
		if(!result) {
			result = `${STORE.CONS.DEBUG_TTS_PATH}${STORE.CONS.MARUI_DOMAIN}${aImgPath}`;
		}
		return result;
	};
	*/

	/**
	 * imgデータ参照時、リリースドメイン以外は
	 * 外部ファイル取得用のパスへ変換
	 * @param  {String} aImgPath	- コンテンツのパス
	 * @param  {String} [aImgType]	- STORE.CONS.IMG_TYPE のいずれか (置換後サフィックス文字列)。未指定または '' で元パス
	 * @return {String}				- 変換済みのパス
	 */
	STORE.UTIL.imgDataPath	= (aImgPath, aImgType)=> {
		if(aImgPath) {
			if(aImgType) {
				if(aImgType == cons.IMG_TYPE.AUTO) {
					aImgType = (STORE.UTIL.getMQDevice() === 'sp') ? STORE.CONS.IMG_TYPE.WEBP_M : STORE.CONS.IMG_TYPE.WEBP_L;
				}

				// クエリ文字列を保持したまま拡張子のみ置換 (例: /foo/bar.jpg?v=1 → /foo/bar-m.webp?v=1)
				if(/\.[a-zA-Z0-9]+(\?.*)?$/.test(aImgPath)) {
					aImgPath = aImgPath.replace(/\.[a-zA-Z0-9]+(\?.*)?$/, aImgType + '$1');
				} else {
					aImgPath = aImgPath + aImgType;
				}
			}

			if(!STORE.UTIL.isProdDomein() && aImgPath.indexOf('http') !== 0) {
				if(STORE.UTIL.getStoreCode() == '010') {
					return STORE.CONS.MARUI_DEV_DOMAIN + aImgPath;
				} else {
					return STORE.CONS.MARUI_DOMAIN + aImgPath;
				}
			}
		}
		return aImgPath;
	};
	
	/**
	 * HTMLテキスト内の画像パスを環境に応じたドメインに変換
	 * @param  {String} aHtmlText	- HTMLテキスト
	 * @return {String}				- 変換済みのHTMLテキスト
	 */
	STORE.UTIL.convertHtmlImgPaths = (aHtmlText, imgType)=> {
		if(!aHtmlText) {
			return aHtmlText;
		}

		// <img src="..."> タグ内のパスを変換
		return aHtmlText.replace(/<img([^>]*)\ssrc=["']([^"']+)["']([^>]*)>/gi, (match, before, imgPath, after)=> {
			// 既にhttpで始まるパス（外部URL）は変換しない
			if(imgPath.indexOf('http') === 0) {
				return match;
			}
			// パスを変換（imgDataPathと同じロジック）
			const convertedPath = STORE.UTIL.imgDataPath(imgPath, imgType);
			return `<img${before} src="${convertedPath}"${after}>`;
		});
	};
	
	/**
	 * データ参照時、リリースドメイン以外は
	 * 外部ファイル取得用のパスへ変換
	 * @param  {String} aContentsPath	- コンテンツのパス
	 * @return {String}				- 変換済みのパス
	 */
	STORE.UTIL.contentsLoadPath	= (aContentsPath)=> {
		if(!STORE.UTIL.isProdDomein() && aContentsPath.indexOf('http') !== 0) {
			if(STORE.UTIL.getStoreCode() == '010') {
				if(STORE.UTIL.isDevDomein()) {
					return aContentsPath;
				} else {
					return STORE.CONS.DEBUG_TTS_PATH + STORE.CONS.MARUI_DEV_DOMAIN + aContentsPath;
				}
			} else {
				return STORE.CONS.DEBUG_TTS_PATH + STORE.CONS.MARUI_DOMAIN + aContentsPath;
			}
		}
		return aContentsPath;
	};

  /**
   * URLからページ種別を取得
   * @return {String} result	- ページ名称文字列
   */
  STORE.UTIL.getPageType = function () {
    var pathAry = location.pathname.split('/');
    var primaryDir = pathAry[2];
    var fileName = pathAry.pop();
    var storeCode = STORE.UTIL.getStoreCode();
    var condOtherStore = /(201|202)/;
    var isOtherStore = condOtherStore.test(storeCode);
    var isNotStaticFeature = /(index|detail)\.html/.test(pathAry[3]);
    var result;

    switch (primaryDir) {
      case '':
      case 'index.html':
        if (isOtherStore) {
          result = 'otherStore';
        } else {
          result = 'storeTop';
        }
        break;

      case 'sale-campaign':
        switch (fileName) {
          case '':
          case 'index.html':
            result = 'saleCampaignList';
            break;
          case 'detail.html':
            result = 'saleCampaignDetail';
            break;
        }
        break;

      case 'mail':
        switch (fileName) {
          case '':
          case 'index.html':
            result = 'mailList';
            break;
          case 'detail.html':
            result = 'mailDetail';
            break;
        }
        break;

      case 'news':
        switch (fileName) {
          case '':
          case 'index.html':
            result = 'newsList';
            break;
          case 'detail.html':
            result = 'newsDetail';
            break;
        }
        break;

      case 'recommend':
        switch (fileName) {
          case '':
          case 'index.html':
            result = 'recommendList';
            break;
          case 'detail.html':
            result = 'recommendDetail';
            break;
        }
        break;

      case 'feature':
        if (isNotStaticFeature || !pathAry[3]) {
          switch (fileName) {
            case '':
            case 'index.html':
              result = 'featureList';
              break;
            case 'detail.html':
              result = 'featureDetail';
              break;
          }
        } else {
          result = 'featureStatic';
        }
        break;

      case 'info':
        switch (fileName) {
          case '':
          case 'index.html':
            result = 'facilityInfo';
            break;
          case 'tel.html':
            result = 'facilityTel';
            break;
        }
        break;

      case 'access':
        result = 'storeAccess';
        break;

      case 'event':
        switch (fileName) {
          case '':
          case 'index.html':
            result = 'storeEvent';
            break;
          case 'detail.html':
            result = 'storeEventDetail';
            break;
        }
        break;

      case 'event-space':
        result = 'storeEventSpace';
        break;

      case 'shop-guide':
        switch (fileName) {
          case 'floor.html':
            result = 'shopGuideFloor';
            break;
          case 'category.html':
            result = 'shopGuideCategory';
            break;
          case 'initial.html':
            result = 'shopGuideInitial';
            break;
          case 'size.html':
            result = 'shopGuideSize';
            break;
          case 'shop-detail.html':
            if (isOtherStore) {
              result = 'otherStoreDetail';
            } else {
              result = 'shopDetail';
            }
            break;
        }
        break;

      case 'facility':
        result = 'facility';
        break;

      case 'restaurant':
      case 'food':
        result = 'restaurant';
        break;

      case 'store-info':
        switch (fileName) {
          case '':
          case 'index.html':
            result = 'storeArticleList';
            break;
          case 'feature.html':
            result = 'storeArticleFeature';
            break;
          case 'fair.html':
            result = 'storeArticleFair';
            break;
          case 'news.html':
            result = 'storeArticleNews';
            break;
        }
        break;

      case 'shop-news':
        switch (fileName) {
          case '':
          case 'index.html':
            result = 'shopNewsList';
            break;
          case 'detail.html':
            if (isOtherStore) {
              result = 'otherStoreNewsDetail';
            } else {
              result = 'shopNewsDetail';
            }
            break;
          case 'shop-list.html':
            if (isOtherStore) {
              result = 'otherStoreNewsTargetList';
            } else {
              result = 'shopNewsTargetList';
            }
            break;
        }
        break;

      case 'newshop':
        switch (fileName) {
          case '':
          case 'index.html':
            result = 'newshopList';
            break;
          case 'detail.html':
            result = 'newshopDetail';
            break;
        }
        break;

      case 'beauty':
        result = 'beauty';
        break;

      case 'campaign':
        result = 'campaign';
        break;

      case 'coupon':
        switch (fileName) {
          case '':
          case 'index.html':
            result = 'couponList';
            break;
          case 'detail.html':
            if (isOtherStore) {
              result = 'otherStoreCouponDetail';
            } else {
              result = 'couponDetail';
            }
            break;
        }
        break;

      case 'recruit':
        result = 'recruit';
        break;

      case 'shop-mail':
        result = 'shopMail';
        break;

      case /^\d{12}_code/.test(primaryDir):
        result = 'shopMailDetail';
        break;

      case 'hash-contents':
        result = 'hashContents';
        break;

      case 'topics':
        result = 'storeTopics';
        break;
    }

    return result;
  };

	/**
	 * [解析用]ページ名称取得
	 * @param  {String} aStoreCode - 店舗番号
	 */
	STORE.UTIL.getAnalyticsPageName = (aStoreCode)=> {
		let pathName    = location.pathname;
		let stcdDelete  = pathName.replace('/' + aStoreCode, '');
		let indexDelete = stcdDelete.replace('index.html', '');
		return STORE.CONS.ANALYTICS_PAGE_NAMES[indexDelete];
	};

	/**
	 * 記事連番、記事タイプと合致する記事抽出
	 * @param {Array} aAllArticleData - 取得記事データ
	 * @param {String} aArticleSeq    - 対象記事連番
	 * @param {String} aArticleType   - 対象記事区分
	 */
	STORE.UTIL.extractTargetArticle = (aAllArticleData, aArticleSeq, aArticleType)=> {
		let result;
		_.some(aAllArticleData, (aArticle)=> {
			let matchSeq  = aArticle.articleSeq === aArticleSeq;
			let matchType = aArticle.articleType === aArticleType;
			if(matchSeq && matchType) {
				result = aArticle;
				return true;
			}
		});
		return result;
	};

  /**
	 * 任意のディレクトリリンクURL生成
	 * @param  {String}	aStcd		- 店舗番号
	 * @param  {String} aSeqKey		- パラメータキー文字列
	 * @param  {String}	aSeq		- 記事連番
	 * @param  {String}	aSecondDir	- ディレクトリー2層目文字列
	 * @param  {String}	aFileName	- リンクするhtmlファイル名
	 * @return {String}	result		- 生成したリンクURL
	 */
	STORE.UTIL.makeCommonLinkUrl	= (aStcd, aSecondDir, aFileName, aSeqKey, aSeq)=> {
		return `/${aStcd}/${aSecondDir}/${aFileName}?${aSeqKey}=${aSeq}`;
	};

	/**
	 * 店舗ニュース開催場所からフロア名を除外
	 * @param  {String} aPlaceText - 開催場所テキスト
	 * @return {String} result     - 除外済みテキスト
	 */
	STORE.UTIL.exclusionStoreNewsPlace = (aPlaceText)=> {
		let convText = STORE.UTIL.convert_zen2han(aPlaceText);
		let result   = '';
		result = convText.replace(/(.*?)\d(.*?)F/, '').trim();
		return result;
	};

	/**
	 * 店舗ニュース開催場所からフロア名を抽出
	 * @param  {String} aPlaceText - 開催場所テキスト
	 * @return {String} result     - 抽出済みテキスト
	 */
	STORE.UTIL.extractStoreNewsFloor = (aPlaceText)=> {
		let convText = STORE.UTIL.convert_zen2han(aPlaceText);
		let result   = '';
		result = convText.match(/(.*?)\d(.*?)F/g);
		return result;
	};

  /**
	 * 店舗ニュース開催場所からイベントカテゴリー名を抽出
	 * @param  {String} aPlaceText - 開催場所テキスト
	 * @return {String} result     - 抽出済みテキスト
	 */
  STORE.UTIL.convertPlaceToCategory = (aPlaceText) => {
		let result   = '';

    if ( aPlaceText.search('カレンダリウム') !== -1 ) {
      result = 'カレンダリウム';
    } else if ( aPlaceText.search(/コンセプト(\s|)ショップス/) !== -1 || aPlaceText.search(/concept(\s|)shops/i) !== -1 ) {
      result = 'コンセプトショップス';
    } else if ( aPlaceText.search('マルイノアニメ') !== -1 ) {
      result = 'マルイノアニメ';
	} else if ( aPlaceText.search('すみだ産業会館') !== -1 ) {
		result = 'すみだ産業会館';
	} else {
      result = '期間限定ショップ';
    }

		return result;
  }

	/**
	 * 変更した店舗名称を取得
	 * @param {String} aStcd - 店舗番号
	 */
	STORE.UTIL.getChangeStoreName = (aStcd) => {
		let result = "";
    if(Object.keys(STORE.CONS.CHANGE_STORE_NAME).includes(aStcd)) {
      result = STORE.CONS.CHANGE_STORE_NAME[aStcd];
    } else {
      result = STORE.CONS.STORE_CODES[aStcd];
    }
    return result;
	};

	/**
	 * 変更した店舗名称(英語)を取得
	 * @param {String} aStcd - 店舗番号
	 */
	STORE.UTIL.getChangeStoreNameEn = (aStcd) => {
		let result = "";
    if(Object.keys(STORE.CONS.CHANGE_STORE_NAME_EN).includes(aStcd)) {
      result = STORE.CONS.CHANGE_STORE_NAME_EN[aStcd];
    } else {
      result = STORE.CONS.STORE_CODES_EN[aStcd];
    }
    return result;
	};

  /**
	 * ショップニュースサブカット
	 * ショップニュース追加商品ソート[昇順]
	 * @param  {Object} a	- 比較対象A
	 * @param  {Object}	b	- 比較対象B
	 * @return {Array}		- ソート済み配列
	 */
	STORE.UTIL.sortShopNewsSub = (a, b)=> {
		let aSort = Number(a.displaySeq);
		let bSort = Number(b.displaySeq);

		if( aSort < bSort ) return -1;
		if( aSort > bSort ) return 1;
		return 0;
	};

  /**
	 * キャンペーン　ソート処理
	 * @param  {Object} a	- 比較対象A
	 * @param  {Object}	b	- 比較対象B
	 * @return {Array}		- ソート済み配列
	 */
	STORE.UTIL.sortCampaignList = (a, b)=> {
		let aSort = Number(a.floorName.replace('F', '0').replace('B', '-').replace('R', '99'));
		let bSort = Number(b.floorName.replace('F', '0').replace('B', '-').replace('R', '99'));

		if( aSort < bSort ) return -1;
		if( aSort > bSort ) return 1;
		return 0;
	};

	/**
	 * デジタルチラシの表示
	 */
	STORE.UTIL.dispDigitalChirashi = ()=> {
		let stcd = STORE.UTIL.getStoreCode();
		let ChirashiId = STORE.CONS.STORE_CHIRASHI_NUMBER[stcd];
		if(typeof ChirashiId !== 'undefined') {
			setCP(ChirashiId);
		} else {
			$('#dgChirashiNav').hide();
		}
	};

	/**
	 * 記事クローズド化判定処理
	 * @param {Array} aAllArticleData - 取得記事データ
	 * @param {Array} aTargetList - クローズド対象記事リスト
	 * @param {String} aStcd - 店舗番号
	 * @return {String} result - 対象記事除外済み配列
	 */
	STORE.UTIL.excludeClosedArticle = (aAllArticleData, aTargetList, aStcd) => {
		let result = [];

		if(_.contains(Object.keys(aTargetList), aStcd)) {
			const targetArticleList = aTargetList[aStcd];

			result = _.filter(aAllArticleData, (aArticleData) => {
				return !_.some(targetArticleList, (aTargetArticle) => {
						return aArticleData.articleSeq === aTargetArticle.seq && aArticleData.articleType === aTargetArticle.type;
				});
			});

			return result;

		} else {

			return aAllArticleData;

		}
	};

	/**
	 * headタグ内にmetaのnoindex追加
	 * @param {Array} aTargetList - 対象記事リスト
	 * @param {String} aStcd - 店舗番号
	 */
	STORE.UTIL.addNoIndexMeta = (aTargetList, aStcd) => {
		const urlQueryParam		= STORE.UTIL.getUrlQueryParam();

		if(_.contains(Object.keys(aTargetList), aStcd)) {
			const targetArticleList = aTargetList[aStcd];

			_.each(targetArticleList, (aTargetArticle) => {
				if(urlQueryParam.article_seq === aTargetArticle.seq && urlQueryParam.article_type === aTargetArticle.type) {
					const head = document.querySelector('head');
					const meta = document.createElement('meta');
					meta.setAttribute('name', 'robots');
					meta.setAttribute('content', 'noindex, nofollow');
					head.appendChild(meta);
				}
			})
		}
	};

	/**
	 * クローズド記事のみ指定バナー表示
	 * @param {Array} aTargetList - 対象記事リスト
	 * @param {String} aStcd - 店舗番号
	 */
	STORE.UTIL.showBnrOnClosedArticle = (aTargetList, aStcd) => {
		const showBnr = {
			'src': '/assets/img/v1/stores/article/bnr_maruko_lc_202403.png',
			'link': 'https://voi.0101.co.jp/voi/content/01/sp/epos/special_offer/2403royal_coupon_store/index.html',
			'target': '_blank',
			'alt': 'マルイのネット通販「マルイウェブチャネル」ご優待情報',
		};
		const urlQueryParam		= STORE.UTIL.getUrlQueryParam();
		let outputHtml = '';

		if(_.contains(Object.keys(aTargetList), aStcd)) {
			const targetArticleList = aTargetList[aStcd];

			_.each(targetArticleList, (aTargetArticle) => {
				const isSeq = urlQueryParam.article_seq === aTargetArticle.seq;
				const isType = urlQueryParam.article_type === aTargetArticle.type;

				if( isSeq && isType ) {
					outputHtml += '<div class="c-show-bnr">';

					if (showBnr.link && showBnr.target) {
						outputHtml += `<a href="${showBnr.link}" target="${showBnr.target}">`;
						outputHtml += `<img src="${showBnr.src}" alt="${showBnr.alt}">`;
						outputHtml += '</a>';
					} else {
						outputHtml += `<img src="${showBnr.src}" alt="${showBnr.alt}">`;
					}

					outputHtml += '</div>';

					$('.c-share').before(outputHtml);
				}
			})
		};
	};

	/**
	 * 対象記事の本文末尾（表示中SHAREの直前）に、記事が指定したHTMLを挿入
	 * @param {Object} aTargetList - 店舗コード → { seq, type, html }
	 * @param {String} aStcd - 店舗番号
	 */
	STORE.UTIL.appendHtmlOnArticle = (aTargetList, aStcd) => {
		const urlQueryParam = STORE.UTIL.getUrlQueryParam();

		if(_.contains(Object.keys(aTargetList), aStcd)) {
			const targetArticle = _.find(aTargetList[aStcd], (aArticle) => {
				return urlQueryParam.article_seq === aArticle.seq && urlQueryParam.article_type === aArticle.type;
			});
			const html = targetArticle && STORE.CONS.APPEND_HTML_ARTICLE[targetArticle.html];

			if(html) {
				$('.c-share:visible').before(html);
			}
		}
	};

	/**
	 * get_utc_time.phpの日時を同期的に取得
	 * @returns {String} get_utc_time.phpの日時 (フォーマット: yyyymmddHHMM, タイムゾーン: Asia/Tokyo)
	 */
	STORE.UTIL.serverDateTime = () => {
		if(NOW_DATE) {
			let yyyy = NOW_DATE.substr(0, 4);
			let mm   = NOW_DATE.substr(4, 2);
			let dd   = NOW_DATE.substr(6, 2);
			let HH   = NOW_DATE.substr(8, 2);
			let MM   = NOW_DATE.substr(10, 2);
	
			let convDate = new Date(`${yyyy}/${mm}/${dd} ${HH}:${MM}`);
			// GMT時間から9時間を加算してJSTへ変換
			convDate.setHours(convDate.getHours() + 9);
			return convDate.getTime();
		} else {
			return null;
		}
	};

	/**
	 * get_utc_time.phpの日時を同期的に取得
	 * @param {String} aTargetString - 対象文字列
	 * @returns {String} デコード後の文字列
	 */
	STORE.UTIL.decodeURI = (aTargetString) => {
		try {
			return decodeURI(aTargetString);
		} catch {
			return aTargetString;
		}
	};	

})();
